import React, {useEffect, useState} from 'react';
import {writeToClipboard} from '@src/helpers/clipboard';
import classnames from '@src/helpers/classnames';

export default function CopyButton(props: {
    text: string,
    size?: 'sm' | 'lg',
}) {
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        if (!isCopied) {
            return;
        }

        const timeout = setTimeout(() => setIsCopied(false), 1500);

        return () => clearTimeout(timeout);
    }, [isCopied]);

    return <button
            type="button"
            className={classnames('btn btn-link', {
                [`btn-${props.size}`]: props.size,
            })}
            onClick={() => {
                writeToClipboard(props.text).then(() => {
                    setIsCopied(true);
                });
            }}
    >
        <i className={classnames('fa', {
            'fa-copy': !isCopied,
            'fa-check text-success': isCopied,
        })}/>
    </button>;
}
